export default "__VITE_ASSET__DkMtZL87__"